// extracted by mini-css-extract-plugin
export default {"SalariesList":"SalariesList_SalariesList__QKXDQ"};